<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm">
      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="부서코드">
              <el-input v-model="form.deptCd" readonly></el-input>
              <el-input v-model="form.deptId" v-show="false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="순서" prop="catNm">
              <el-input v-model="form.deptIdx"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="24">
            <el-form-item label="부서명" prop="catKey">
              <el-input v-model="form.deptNm"></el-input>
            </el-form-item>
          </el-col>
      </el-row>

      <el-row>
          <el-col :span="24">
            <el-form-item label="상위부서면">
              <el-input v-model="parentNm" readonly></el-input>
            </el-form-item>
          </el-col>
      </el-row>

    </el-form>
  </div>
</template>

<script>
export default {
  name: "DeptInfo",
  props: ['deptDetail' , 'parentNm'],
  data() {
    return {
      form: {
        deptKey: "",
        deptNm: "",
        deptId: "",
        parentId: "",
        deptIdx: "",
        parentNm: "",
      },
      catLvl : 1,
    };
  },
  methods: {
    setdeptInfo() {
      this.form = this.deptDetail;
      this.form.parentNm = this.parentNm;
    },
  },
  watch: {
    deptDetail() {
      this.setdeptInfo();
    }
  }
}

</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}

</style>